/**
 * 🤖 AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * This file is automatically generated by vite-plugins/markdown-routes.ts
 * Source: content/blog/ongoing/making-music-anywhere.md
 *
 * ⚠️ Any manual changes will be overwritten on next build.
 *
 * To modify this blog post:
 * 1. Edit the source markdown file: content/blog/ongoing/making-music-anywhere.md
 * 2. Run the build process to regenerate this file
 */

import { createFileRoute } from '@tanstack/react-router';
import { ArticleLayout } from '@/components/ArticleLayout';
import { createArticleMeta } from '@/lib/meta';
import Content from '@/content/making-music-anywhere.mdx';

const metadata = {
  slug: "making-music-anywhere",
  title: "Making Music Anywhere",
  author: "Christian Battaglia",
  description: "The platform-agnostic musician's guide — open source first, free as in freedom. From hardware setup (Mackie mixer, MIDI keyboard, XLR mic) to software (Ardour DAW, free VST plugins) to music theory fundamentals, all on Windows, macOS, Linux, iOS, and Android.\n",
  authorImage: "/assets-cdbattaglia/media/images/chris_profile.svg",
  
  date: "2019-05-06T00:00:00.000Z",
  
  readTime: "8 min read",
  tags: ["music production","Ardour","VST","MIDI","open source","cross-platform","Mackie","music theory","Jacob Collier","Spotify API"],
};

export const Route = createFileRoute('/blog/posts/making-music-anywhere')({
  component: ArticlePage,
  head: () => createArticleMeta({
    title: `${metadata.title}${metadata.author ? ` - ${metadata.author}` : ''}`,
    description: metadata.description || '',
    path: '/blog/posts/making-music-anywhere',
    image: '/og/blog/making-music-anywhere.png',
    imageAlt: metadata.title,
    datePublished: metadata.date,
    dateModified: undefined,
    authorName: metadata.author,
    tags: metadata.tags,
    readTime: metadata.readTime,
    section: 'Blog',
  }),
});

function ArticlePage() {
  return (
    <ArticleLayout {...metadata}>
      <Content />
    </ArticleLayout>
  );
}
